import React from 'react'
import { useTranslation } from 'react-i18next'
import useBillingInformation from '../../../services/subscription/useBillingInformation'
import CompanyBillingInformationForm from './CompanyBillingInformationForm'
import Spinner from '../../UI/Spinner'
import LoadFailed from '../../UI/LoadFailed'

const CompanyBillingInformationLoader = () => {
  const { t } = useTranslation()
  const {
    data: billingInformation,
    isInitialLoading,
    isError,
    refetch,
  } = useBillingInformation()

  // Failure wins over loading: a retrying query still reports as loading,
  // which would otherwise hide the error indefinitely.
  if (isError) {
    return (
      <div className='mt-10'>
        <LoadFailed
          message={t('failedToLoadBillingInformation')}
          onRetry={refetch}
        />
      </div>
    )
  }

  if (isInitialLoading) {
    return (
      <div className='mt-10 flex items-center justify-center'>
        <Spinner spinner='form' width='w-11' height='h-11' color='#0C75FF' />
      </div>
    )
  }

  // The form saves by PATCHing the record's own id, so with no record there is
  // nothing it could write. Say so rather than render a form that cannot save.
  if (!billingInformation) {
    return (
      <p className='mt-10 text-lightGray'>{t('noBillingInformationFound')}</p>
    )
  }

  return (
    <CompanyBillingInformationForm billingInformation={billingInformation} />
  )
}

export default CompanyBillingInformationLoader
